export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="rounded-2xl bg-background-50 border border-background-200 p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              移动阅读
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              妖精漫画网全面适配移动端浏览器，无需下载应用即可在手机上流畅阅读。
              随时随地下拉追更，精彩漫画尽在掌中。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <div className="flex items-center gap-2 px-4 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium cursor-pointer whitespace-nowrap">
                <i className="ri-smartphone-line"></i>
                <span>手机端访问</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-3 rounded-full border border-background-300 text-foreground-700 text-sm font-medium cursor-pointer hover:bg-background-100 transition-colors whitespace-nowrap">
                <i className="ri-tablet-line"></i>
                <span>平板端体验</span>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full max-w-xs lg:max-w-sm">
            <div className="relative w-full aspect-[9/16] rounded-2xl overflow-hidden bg-background-200 mx-auto max-w-[240px]">
              <img
                src="https://readdy.ai/api/search-image?query=A%20beautiful%20smartphone%20mockup%20displaying%20a%20manga%20reading%20app%20interface%20with%20a%20colorful%20manga%20page%20on%20screen%20the%20phone%20floating%20against%20a%20soft%20gradient%20background%20with%20pink%20and%20warm%20golden%20tones%20clean%20modern%20design%20with%20subtle%20glow%20effect%20premium%20product%20photography&width=480&height=854&seq=app-mockup-01&orientation=portrait"
                alt="妖精漫画网移动端阅读体验"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}